<template>
  <el-dialog  :visible="show" title="复制作品" width="600px" append-to-body @close="closeDialog">
    <el-form v-loading="loading" label-width="100px" ref="vForm" :model="vForm" size="medium">
      <el-form-item label="所属区域" prop="area_id" :rules="{ required: true, message: '关联区域必填' }">
        <el-cascader v-model="areaData" :options="areaList" :props="{ value: 'id', label: 'name', children: 'child' }" placeholder="请选择" style="width: 100%" filterable @change="vForm.area_id = areaData[areaData.length - 1]" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

	export default {
		props: ['show','row'],

		data() {
			return {
				doSubmitLoading: false,
				loading: false,
				category: [],
				areaList: [],
				userLevel: this.$store.getters.userInfo.level,
				vForm: {
					works_id: this.row.id,
					area_id: '',
				},
				areaData: [],
				thumb: {key: '', name: '', preview: ''},
			};
		},

		created() {
			this.getArea();

		},

		methods: {

			closeDialog() {
				this.$emit('update:show', false);
			},

			async getArea() {
				this.loading = true;
				try {
					this.areaList = await this.$store.dispatch('user/getAreaList');
					if (this.userLevel == 3) {
						this.vForm.area_id = this.areaList[0].id;
					}
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//提交作品
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					let data = JSON.parse(JSON.stringify(this.vForm));
					await this.api.works.copyData(this.vForm);
					this.$message.success('复制成功');
					this.$emit('success');
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},
		},
	};
</script>

